export const AIT_STATEMENTS = [
  'Reading your property data...',
  "Checking each building's average...",
  'Cross-referencing AMI bands...',
  'Modeling redesignation paths...',
  'Watching for concentration risk...',
  'Weighing flexibility against pressure...',
  'Compiling recommendations...',
  'Tip: Keep a 2-3% buffer below 60% as a safety margin.',
  'Tip: 70% and 80% units offset lower-AMI designations.',
  'Tip: Manager units are excluded from AIT calculations.',
  'Tip: Lease-up requires 40% qualified by year-end.',
  'Tip: The next-available-unit rule fires when a qualified household goes over income.',
  'Tip: Save a snapshot before making major designation changes.',
  'Tip: Concentration risk grows when too many units cluster at 70-80%.',
  'Tip: Run a scenario before committing a redesignation.',
];

export const UNIFIED_CHAT_STATEMENTS = [
  'Pulling context...',
  'Drafting a response...',
  'Cross-referencing your data...',
  'Thinking it through...',
  'Reviewing your prompt...',
  'Searching your project...',
  'Almost there...',
  'Tip: Mention @JPro in any thread to bring the assistant in.',
  'Tip: Pin a reasoning mode to keep it across chats.',
  'Tip: Save a prompt to reuse it later from the saved prompts library.',
  'Tip: Drag a file into the input to attach it.',
  'Tip: Use voice input from the microphone icon.',
  'Tip: Switch projects from the sidebar to scope the context.',
  'Tip: Add notes from any answer with the sticky-note icon.',
];

export const IMAGE_GEN_STATEMENTS = [
  'Composing the scene...',
  'Sketching the layout...',
  'Choosing the palette...',
  'Rendering details...',
  'Polishing edges...',
  'Lighting the frame...',
  'Refining the composition...',
  'This may take a moment...',
  'Tip: Reference slots anchor a style across variants.',
  'Tip: Use the prompt refiner to sharpen vague ideas.',
  'Tip: Generate variants to compare different takes side-by-side.',
  'Tip: Specific nouns and lighting cues sharpen the output.',
  'Tip: Upload a reference image to guide the result.',
];
